import {Controller} from "@hotwired/stimulus"
export default class UserCardController extends Controller {

    connect(e) {
        this.payment_type = 'card'
    }

    selectPaymentType(e){
        this.payment_type = e.currentTarget.value
    }

    next(e){
        e.preventDefault()
        if(this.payment_type == 'card'){
            $('.card_list').removeClass('d-none')
            $('.select_card_type').addClass('d-none')
        }
    }
}